export const bibleBooks = [
    { title: "Genesis", chapters: 50 }, { title: "Exodus", chapters: 40 },
    { title: "Leviticus", chapters: 27 }, { title: "Numbers", chapters: 36 },
    { title: "Deuteronomy", chapters: 34 }, { title: "Joshua", chapters: 24 },
    { title: "Judges", chapters: 21 }, { title: "Ruth", chapters: 4 },
    { title: "1 Samuel", chapters: 31 }, { title: "2 Samuel", chapters: 24 },
    { title: "1 Kings", chapters: 22 }, { title: "2 Kings", chapters: 25 },
    { title: "1 Chronicles", chapters: 29 }, { title: "2 Chronicles", chapters: 36 },
    { title: "Ezra", chapters: 10 }, { title: "Nehemiah", chapters: 13 },
    { title: "Esther", chapters: 10 }, { title: "Job", chapters: 42 },
    { title: "Psalms", chapters: 150 }, { title: "Proverbs", chapters: 32 }, // Intentional Extra Proverbs
    { title: "Ecclesiastes", chapters: 12 }, { title: "Song of Solomon", chapters: 8 },
    { title: "Isaiah", chapters: 66 }, { title: "Jeremiah", chapters: 52 },
    { title: "Lamentations", chapters: 5 }, { title: "Ezekiel", chapters: 48 },
    { title: "Daniel", chapters: 12 }, { title: "Hosea", chapters: 14 },
    { title: "Joel", chapters: 3 }, { title: "Amos", chapters: 9 },
    { title: "Obadiah", chapters: 1 }, { title: "Jonah", chapters: 4 },
    { title: "Micah", chapters: 7 }, { title: "Nahum", chapters: 3 },
    { title: "Habakkuk", chapters: 3 }, { title: "Zephaniah", chapters: 3 },
    { title: "Haggai", chapters: 2 }, { title: "Zechariah", chapters: 14 },
    { title: "Malachi", chapters: 4 }, { title: "Matthew", chapters: 28 },
    { title: "Mark", chapters: 16 }, { title: "Luke", chapters: 24 },
    { title: "John", chapters: 21 }, { title: "Acts", chapters: 28 },
    { title: "Romans", chapters: 16 }, { title: "1 Corinthians", chapters: 16 },
    { title: "2 Corinthians", chapters: 13 }, { title: "Galatians", chapters: 6 },
    { title: "Ephesians", chapters: 6 }, { title: "Philippians", chapters: 4 },
    { title: "Colossians", chapters: 4 }, { title: "1 Thessalonians", chapters: 6 }, // Intentional Extra 1 Thessalonians
    { title: "2 Thessalonians", chapters: 3 }, { title: "1 Timothy", chapters: 6 },
    { title: "2 Timothy", chapters: 4 }, { title: "Titus", chapters: 3 },
    { title: "Philemon", chapters: 1 }, { title: "Hebrews", chapters: 13 },
    { title: "James", chapters: 5 }, { title: "1 Peter", chapters: 5 },
    { title: "2 Peter", chapters: 3 }, { title: "1 John", chapters: 5 },
    { title: "2 John", chapters: 1 }, { title: "3 John", chapters: 1 },
    { title: "Jude", chapters: 2 } , { title: "Revelation", chapters: 22 } // Intentional Extra Jude
];

export const TOTAL_CELLS = bibleBooks.reduce((acc, book) => acc + book.chapters, 0) + bibleBooks.length;

export const WIDTH_OFFSET = 2;
export const DEFAULT_MAX_COLUMNS = 34;
export const DEFAULT_VERSE_THRESHOLD = 11;
export const DEFAULT_MAX_VERSES = 1;
export const DEFAULT_MAX_FONT_SIZE = 22;

export const getSanitizedBookName = (title: string): string => {
    return title.replace(/\s+/g, "").replace(/^(\d)/, "b$1").toLowerCase();
};

export const bookColorGroupsSequence = {
    group1: ["genesis", "b1samuel", "esther", "lamentations", "micah", "mark", "ephesians", "philemon", "jude"],
    group2: ["exodus", "b2samuel", "job", "ezekiel", "nahum", "luke", "philippians", "hebrews", "revelation"],
    group3: ["leviticus", "b1kings", "psalms", "daniel", "habakkuk", "john", "colossians", "james"],
    group4: ["numbers", "b2kings", "proverbs", "hosea", "zephaniah", "acts", "b1thessalonians", "b1peter"],
    group5: ["deuteronomy", "b1chronicles", "ecclesiastes", "joel", "haggai", "romans", "b2thessalonians", "b2peter"],
    group6: ["joshua", "b2chronicles", "songofsolomon", "amos", "zechariah", "b1corinthians", "b1timothy", "b1john"],
    group7: ["judges", "ezra", "isaiah", "obadiah", "malachi", "b2corinthians", "b2timothy", "b2john"],
    group8: ["ruth", "nehemiah", "jeremiah", "jonah", "matthew", "galatians", "titus", "b3john"],
};

export const bookColorGroupsSections = {
    law: ["genesis", "exodus", "leviticus", "numbers", "deuteronomy"],
    historyOT: ["joshua", "judges", "ruth", "b1samuel", "b2samuel", "b1kings", "b2kings", "b1chronicles", "b2chronicles", "ezra", "nehemiah", "esther"],
    poetryWisdom: ["job", "psalms", "proverbs", "ecclesiastes", "songofsolomon"],
    majorProphets: ["isaiah", "jeremiah", "lamentations", "ezekiel", "daniel"],
    minorProphets: ["hosea", "joel", "amos", "obadiah", "jonah", "micah", "nahum", "habakkuk", "zephaniah", "haggai", "zechariah", "malachi"],
    gospelsActs: ["matthew", "mark", "luke", "john", "acts"],
    paulineEpistles: ["romans", "b1corinthians", "b2corinthians", "galatians", "ephesians", "philippians", "colossians", "b1thessalonians", "b2thessalonians", "b1timothy", "b2timothy", "titus", "philemon"],
    generalEpistlesRevelation: ["hebrews", "james", "b1peter", "b2peter", "b1john", "b2john", "b3john", "jude", "revelation"],
};

export const paletteColors = {
    paletteSpectrum: {
        name: "Spectrum",
        bookCellColors: ["#7185E9", "#33BEB7", "#B2C224", "#f8a227", "#f66222", "#da3a3a", "#F1667D", "#a564da"],
        bookCellText: '#000000',
        page: '#000000',
        marker: '#FFFFFF',
        pencil: '#7f7f7f',
        overlayBg: 'rgba(0, 0, 0, 0.95)',
        targetOutlineColor: '#FFFFFF',
    },
    paletteGarden: {
        name: "Garden",
        bookCellColors: ["#033c5d","#1f2d16", "#585916", "#487d81", "#742340","#a62b0a", "#f86b40", "#095d7f"],
        bookCellText: '#FFFFFF',
        page: '#faf7f2',
        marker: '#1f2d16',
        pencil: '#4b3114',
        overlayBg: 'rgba(245, 245, 245, 0.95)',
        targetOutlineColor: '#e2b98a',
    },
        paletteForest: {
        name: "Forest",
        bookCellColors: ["#7b8258", "#bea749", "#56632d", "#c2a681", "#b87756", "#a0a0a0", "#aab5a7", "#9a8c72"],
        bookCellText: '#000000',
        page: '#141207',
        marker: '#d3d2c6',
        pencil: '#7f7f7f',
        overlayBg: 'rgba(245, 245, 245, 0.95)',
        targetOutlineColor: '#d3d2c6',
    },
    paletteNatural: {
        name: "Natural",
        bookCellColors: ["#e8e5dc", "#ffffff", "#e7dfd0", "#c8bcac", "#e3d6d6", "#cdaf9d", "#e5d1c5", "#f2d9c3"],
        bookCellText: '#2f2b27',
        page: '#faf7f2',
        marker: '#2f2b27',
        pencil: '#4b3114',
        overlayBg: 'rgba(245, 245, 245, 0.95)',
        targetOutlineColor: '#2f2b27',
    },
    paletteDark: {
        name: "Dark",
        bookCellColors: ["#0e1013", "#17181b", "#0e1013", "#17181b", "#0e1013", "#17181b", "#0e1013", "#17181b"],
        bookCellText: '#bdc1c6',
        page: '#000000',
        marker: '#bdc1c6',
        pencil: '#7f7f7f',
        overlayBg: 'rgba(0, 0, 0, 0.95)',
        targetOutlineColor: '#bdc1c6',
    },
    paletteCandy: {
        name: "Candy",
        bookCellColors: ["#EBD3E9", "#F6A8E0", "#F8EDFB", "#A9B0E4", "#F5D8E2", "#C4E7F5", "#FCF2D1", "#FFDAEB"],
        bookCellText: '#000000',
        page: '#FDFDFD',
        marker: '#333333',
        pencil: '#7f7f7f',
        overlayBg: 'rgba(245, 245, 245, 0.95)',
        targetOutlineColor: '#333333',
    },
    paletteScarf: {
        name: "Scarf",
        bookCellColors: ["#A36A33", "#703642", "#c44037", "#e9aa2f", "#61596c", "#6e652c", "#908575", "#8C5C8D"],
        bookCellText: '#EFE7DB',
        page: '#dbcab0',
        marker: '#000000',
        pencil: '#7f7f7f',
        overlayBg: 'rgba(245, 245, 245, 0.95)',
        targetOutlineColor: '#333333',
    },
    paletteRainbow: {
        name: "Rainbow",
        bookCellColors: ["#7185E9", "#33BEB7", "#B2C224", "#f8a227", "#f66222", "#da3a3a", "#F1667D", "#a564da"],
        bookCellText: '#000000',
        page: '#FDFDFD',
        marker: '#000000',
        pencil: '#7f7f7f',
        overlayBg: 'rgba(245, 245, 245, 0.95)',
        targetOutlineColor: '#333333',
    },
    paletteHacker: { 
        name: "Hacker",
        bookCellColors: ["#010D0A", "#010D0A", "#010D0A", "#010D0A", "#010D0A", "#010D0A", "#010D0A", "#010D0A"],
        bookCellText: '#9BFF58',
        page: '#010D0A',
        marker: '#9BFF58',
        pencil: '#9BFF58',
        overlayBg: 'rgba(10, 10, 10, 0)',
        targetOutlineColor: '#9BFF58',
    },
    paletteOcean: {
        name: "Ocean",
        bookCellColors: ["#7A9ED0", "#A2DAEB", "#4CABE1", "#bfe3f1", "#55a2be", "#aedbd4", "#66acae", "#c7dfcf"],
        bookCellText: '#000000',
        page: '#061B29',
        marker: '#E7F0F7',
        pencil: '#BBBBBB',
        overlayBg: 'rgba(20, 20, 30, 0.95)',
        targetOutlineColor: '#E0E0E0',
    },
    paletteAutumn: {
        name: "Autumn",
        bookCellColors: ["#9a4a27", "#d69865", "#b36938", "#b98f67", "#9e7269", "#cca79f", "#996b4a", "#ebca9f"],
        bookCellText: '#000000',
        page: '#180503',
        marker: '#EBCA9F',
        pencil: '#BBBBBB',
        overlayBg: 'rgba(40, 30, 20, 0.95)',
        targetOutlineColor: '#FFE0C0',
    },
};

export interface BookProps {
    style: { gridColumn: string, gridRow: string };
    'data-book': string;
    'data-part': number; // Assuming this was intended, if not, it can be removed.
    className?: string;
}

export interface SearchResult {
    book: string;
    chapter: number;
    verse: number;
    text: string;
}

// Type for individual palette details (used in Header and App)
export type PaletteDetails = {
    name: string;
    bookCellColors: string[];
    bookCellText: string;
    page: string;
    marker: string;
    pencil: string;
    overlayBg: string;
    targetOutlineColor: string;
};

// Type for the entire paletteColors object (used in Header and App)
export type PaletteColors = {
    [key: string]: PaletteDetails;
};
